<template>
  <div :class="styleMain">
    <h2>{{ statistic.name }}</h2>
    <el-button plain icon="el-icon-plus" size="mini" @click="more" />
    <el-button plain icon="el-icon-minus" size="mini" @click="less" />
    <el-input v-model="value" @change="updateTotal" size="mini" />
    <el-input :value="valueActions" type="primary" size="mini" readonly />
    <el-input :value="valueMatch" type="success" size="mini" readonly />
  </div>
</template>

<script>
import { ucFirst } from '@/helpers/format'

export default {
  name: 'SportFootballMatchTeamStatisticsTemplate',
  props: {
    match: Object,
    team: Object,
    statistic: Object
  },
  data () {
    return {
      state: null
    }
  },
  computed: {
    homeAway () { return this.match?.homeAway(this.team) },
    statisticName () { return this.statistic.match + ucFirst(this.homeAway) },
    valueMatch () { return this.match ? this.match[this.statisticName] : null },
    valueActions () { return this.$store.getters['Sport/Football/Match/matchActionsStatistics'](this.match?.id, this.statisticName) },
    value: {
      get () {
        return this.state || this.valueMatch - this.valueActions
      },
      set (value) {
        this.state = value
      }
    },
    styleMain () { return ['sportFootballMatchTeamStatisticsTemplate', this.homeAway] }
  },
  methods: {
    updateTotal (value) {
      this.update(parseInt(value) + this.valueActions)
    },
    more () {
      this.update(this.valueMatch + 1)
    },
    less () {
      this.update(this.valueMatch - 1)
    },
    update (value) {
      const data = { id: this.match.id }
      data[this.statisticName] = value
      this.$store.dispatch('Sport/Football/Match/put', data)
    }
  }
}
</script>

<style>
.sportFootballMatchTeamStatisticsTemplate{
  position:relative;
  height:46px;
  margin:0 24px 2px 24px;
  padding:0 16px;
  background-color:var(--color-background-grey);
  border-radius:4px;
  box-sizing: border-box;
  display:flex;
}
.sportFootballMatchTeamStatisticsTemplate.away{
  flex-direction:row-reverse;
}
.sportFootballMatchTeamStatisticsTemplate > h2{
  flex:1;
  font-size:14px;
  font-weight:bold;
  line-height: 14px;
  align-self: center;
}
.sportFootballMatchTeamStatisticsTemplate.home > h2{
  text-align: left;
}
.sportFootballMatchTeamStatisticsTemplate.away > h2{
  text-align: right;
}
.sportFootballMatchTeamStatisticsTemplate > button{
  flex:0 0 auto;
  width:30px;
  height:30px;
  padding:0;
  align-self: center;
  text-align: center;
}
.sportFootballMatchTeamStatisticsTemplate > div{
  flex:0 0 auto;
  width:30px;
  height:30px;
  padding:0;
  align-self: center;
  text-align: center;
}
.sportFootballMatchTeamStatisticsTemplate.home .el-button+.el-button,
.sportFootballMatchTeamStatisticsTemplate.home .el-button+.el-input,
.sportFootballMatchTeamStatisticsTemplate.home .el-input+.el-input {
    margin: 0 0 0 4px;
}
.sportFootballMatchTeamStatisticsTemplate.away .el-button+.el-button,
.sportFootballMatchTeamStatisticsTemplate.away .el-button+.el-input,
.sportFootballMatchTeamStatisticsTemplate.away .el-input+.el-input {
    margin: 0 4px 0 0;
}
.sportFootballMatchTeamStatisticsTemplate > button > i{
  color:black;
  font-size:14px;
  font-weight:bold;
}
.sportFootballMatchTeamStatisticsTemplate.home .el-button.is-plain:focus,
.sportFootballMatchTeamStatisticsTemplate.home .el-button.is-plain:hover{
  border-color: var(--color-team-home)
}
.sportFootballMatchTeamStatisticsTemplate.away .el-button.is-plain:focus,
.sportFootballMatchTeamStatisticsTemplate.away .el-button.is-plain:hover{
  border-color: var(--color-team-away)
}
.sportFootballMatchTeamStatisticsTemplate .el-input input{
  width:30px;
  height:30px;
  padding:0;
  text-align: center;
  font-size:14px;
  font-weight:bold;
}
.sportFootballMatchTeamStatisticsTemplate.home .el-input.is-active .el-input__inner,
.sportFootballMatchTeamStatisticsTemplate.home .el-input__inner:focus{
  border-color: var(--color-team-home)
}
.sportFootballMatchTeamStatisticsTemplate.away .el-input.is-active .el-input__inner,
.sportFootballMatchTeamStatisticsTemplate.away .el-input__inner:focus{
  border-color: var(--color-team-away)
}
.sportFootballMatchTeamStatisticsTemplate.home .el-input input[type="primary"]{
  color:white;
  background-color: var(--color-team-home)
}
.sportFootballMatchTeamStatisticsTemplate.away .el-input input[type="primary"]{
  color:white;
  background-color: var(--color-team-away)
}
.sportFootballMatchTeamStatisticsTemplate .el-input input[type="success"]{
  background-color:transparent;
  border:none
}
</style>
